import { EpDevPPluginIds } from "../../constants";
import EpDevPUtils from "../../EpDevPUtils";
import { 
  TEpDevPHealthApiHealthQueryParams,
  TEpDevPHealthApiPluginHealthPathParams, 
  TEpDevPHealthApiPluginHealthQueryParams 
} from "../types";

const HEALTH_PATH = "health";
const PLUGIN_PATH = "plugin";

export class EpDevPHealthApiRoutesFactory {

  public static getSubRouteBase = (): string => {
    return `/${HEALTH_PATH}`;
  }
  public static getSubRouteHealth = (): string => { 
    return EpDevPHealthApiRoutesFactory.getSubRouteBase();
  }
  private static subRoutePluginHealth = (): string => { 
    return `${EpDevPHealthApiRoutesFactory.getSubRouteBase()}/${PLUGIN_PATH}/:${EpDevPUtils.nameOf<TEpDevPHealthApiPluginHealthPathParams>("pluginId")}`;
  }
  public static getSubRoutePluginHealth = (): string => { 
    return EpDevPHealthApiRoutesFactory.subRoutePluginHealth();
  }
  public static postSubRoutePluginHealth = (): string => { 
    return EpDevPHealthApiRoutesFactory.subRoutePluginHealth();
  }
}

export class EpDevPHealthApiPathsFactory {

  public static createGetHealthPath({ includeDetails }:{
    includeDetails?: boolean;
  }): string {
    const queryParams: string[] = [];
    if(includeDetails !== undefined) {
      if(includeDetails === true) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPHealthApiHealthQueryParams>("includeDetails")}=true`);
      else queryParams.push(`${EpDevPUtils.nameOf<TEpDevPHealthApiHealthQueryParams>("includeDetails")}=false`);
    }
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${HEALTH_PATH}?${queryString}`;
  }

  public static createGetPluginHealthPath({ pluginId, includeDetails }:{
    pluginId: EpDevPPluginIds;
    includeDetails?: boolean;
  }): string {
    const queryParams: string[] = [];
    if(includeDetails !== undefined) {
      if(includeDetails === true) queryParams.push(`${EpDevPUtils.nameOf<TEpDevPHealthApiPluginHealthQueryParams>("includeDetails")}=true`);
      else queryParams.push(`${EpDevPUtils.nameOf<TEpDevPHealthApiPluginHealthQueryParams>("includeDetails")}=false`);
    }
    const queryString = queryParams.length ? queryParams.join('&') : '';
    return `/${HEALTH_PATH}/${PLUGIN_PATH}/${pluginId}?${queryString}`;
  }

  public static createSetPluginHealthPath({ pluginId }:{
    pluginId: EpDevPPluginIds;
  }): string {
    return `/${HEALTH_PATH}/${PLUGIN_PATH}/${pluginId}`;
  }

}
